import { Subscription } from 'rxjs';
import { Component } from '@angular/core';

import { ToastData, ToastOptions, ToastyConfig, ToastyService } from 'ng2-toasty';

import { Notification } from './core/errors/model/notification.model';
import { NotificationType } from './core/errors/model/notification-type.model';
import { NotificationService } from './core/errors/services/notification.service';
import {NavigationEnd, Router} from "@angular/router";

@Component({
  selector: 'app-root',
  template:  `
    <ng2-toasty [position]="'top-right'"></ng2-toasty>
    <router-outlet></router-outlet>`
})
export class AppComponent {

  notifications$: Subscription;

  constructor(private router: Router,
              private toastyConfig: ToastyConfig,
              private toastyService: ToastyService,
              private notificationService: NotificationService) {
    this.onNotification();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        (<any>window).ga('send', 'pageview');
      }
    });
  }

  /**
   * Se inscreve nas notificacoes, irá receber e exibir os avisos
   * disparados por componentes filhos
   */
  onNotification(): void {
    this.toastyConfig.theme = 'bootstrap';
    this.notifications$ = this.notificationService.getNotification().subscribe(
        (res: Notification) => {
          const toastOptions: ToastOptions = {
            title: res.title,
            msg: res.message,
            showClose: true,
            timeout: res.time,
            onAdd: (toast: ToastData) => {},
            onRemove: function(toast: ToastData) {}
          };
          switch (res.type) {
            case NotificationType.INFO:
              this.toastyService.info(toastOptions);
              break;
            case NotificationType.SUCCESS:
              this.toastyService.success(toastOptions);
              break;
            case NotificationType.WARNING:
              this.toastyService.warning(toastOptions);
              break;
            case NotificationType.ERROR:
              this.toastyService.error(toastOptions);
              break;
          }
        }
    )
  }
}
